import { t } from "@web-monorepo/i18n/macro";
import { DDSIconButton } from "@web-monorepo/dds";
import { IconX } from "@web-monorepo/dds-icons";
import { once } from "es-toolkit/compat";
import React from "react";
import FullBleedScreen from "./BeyondToolkit/FullBleedScreen";
import styles from "./ToolkitVideoPlayer.module.css";

type ToolkitVideoPlayerProps = {
  onClose: VoidFunction;
  sendUsage: VoidFunction;
  videoSrc: string;
};

type ExtendedHTMLVideoElement = HTMLVideoElement & {
  mozRequestFullScreen: VoidFunction;
  requestFullScreen: VoidFunction;
  webkitRequestFullScreen: VoidFunction;
};

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
class ToolkitVideoPlayer extends React.Component<ToolkitVideoPlayerProps> {
  componentDidMount() {
    document.addEventListener("visibilitychange", this._onVisibilityChange);

    if (this.videoNode?.requestFullScreen) {
      this.videoNode.requestFullScreen();
    } else if (this.videoNode?.mozRequestFullScreen) {
      this.videoNode.mozRequestFullScreen();
    } else if (this.videoNode?.webkitRequestFullScreen) {
      this.videoNode.webkitRequestFullScreen();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("visibilitychange", this._onVisibilityChange);
  }

  render() {
    return (
      <FullBleedScreen>
        <div className={styles.content}>
          <div className={styles.closeButton}>
            <DDSIconButton
              variant="transparent"
              aria-label={t`Close`}
              data-name="toolkit_video_player:close"
              tooltip={{ content: t`Close`, dataName: "toolkit_video_player:close:tooltip" }}
              onClick={() => this.props.onClose()}
            >
              <IconX />
            </DDSIconButton>
          </div>
          {/* eslint-disable-next-line jsx-a11y/media-has-caption -- educational video content, captions not available */}
          <video
            className={styles.video}
            controls
            autoPlay
            src={this.props.videoSrc}
            ref={(node: ExtendedHTMLVideoElement) => (this.videoNode = node)}
            onPlay={this._sendUsage}
            onEnded={() => this.props.onClose()}
          />
        </div>
      </FullBleedScreen>
    );
  }

  videoNode: ExtendedHTMLVideoElement | null | undefined;

  _onVisibilityChange = () => {
    if (document.hidden) {
      this.videoNode?.pause();
    }
  };

  _sendUsage = once(() => {
    this.props.sendUsage();
  });
}

export default ToolkitVideoPlayer;
